(function () {
  const SELECTOR = '.jdgm-cards-carousel a[target="_blank"]';

  function fixLinks(root) {
    root.querySelectorAll(SELECTOR).forEach((link) => {
      try {
        const url = new URL(link.href, window.location.origin);
        if (url.origin === window.location.origin) {
          link.removeAttribute('target');
          link.removeAttribute('rel');
        }
      } catch (_) {}
    });
  }

  function init() {
    fixLinks(document);
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType === 1) fixLinks(node);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
